import { OrganizationApplicationParameters } from '@platform/client/schemas';
import { FormsMultilineInput } from '@platform/components';
import { useState } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';
import { ApplicationPageProps } from '../../Application';
import { useApplicationLocalStorage } from '../../application-hook';
import { ApplicationBackground } from '../../ApplicationBackground';
import { ApplicationPageContent } from '../../components/ApplicationPageContent';
import { NeedHelpButton } from '../../components/NeedHelpButton';
import BackgroundImage from '../../images/Leftsection2-org.svg';

type FormValues = {
  problem: string;
};

export const OrgProblemSelection = (props: ApplicationPageProps) => {
  const { onBack, onContinue, progress } = { ...props };

  const [showExample, setShowExample] = useState(false);

  const { updateApplicationData, getApplicationDataByKey } =
    useApplicationLocalStorage<OrganizationApplicationParameters>();

  const {
    control,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm<FormValues>({
    mode: 'onBlur',
    reValidateMode: 'onChange',
    defaultValues: {
      problem: getApplicationDataByKey('problem') || '',
    },
  });

  const submit: SubmitHandler<FormValues> = (data) => {
    updateApplicationData({
      problem: data.problem,
    });
    onContinue();
  };

  const handleBack = () => {
    updateApplicationData({
      problem: watch('problem'),
    });
    onBack();
  };

  return (
    <ApplicationBackground
      progress={progress}
      isOrganization={true}
      onBack={handleBack}
      onSubmit={handleSubmit(submit)}
      backgroundImage={BackgroundImage}
      isEditProfile={props.isEditProfile}
    >
      <ApplicationPageContent
        title='What problem is your organization solving, and who are you solving it for?'
        description={
          'This helps us understand your mission and match you with the right support. You can always update it later.'
        }
      >
        <FormsMultilineInput
          control={control}
          placeholder="Describe how your product or service addresses the problem you're solving."
          rules={{
            maxLength: 500,
            required: 'Describe what problem your organization is trying to solve to continue',
          }}
          name='problem'
          formsError={errors.problem}
          characterCount={500}
        />
        <NeedHelpButton
          onClick={() => setShowExample(!showExample)}
          isOpen={showExample}
          helpContent={
            "We help smallholder farmers in rural Kenya access affordable solar-powered irrigation systems. Many face water scarcity and can't afford traditional solutions. Our goal is to boost their crop yields and incomes sustainably."
          }
        />
      </ApplicationPageContent>
    </ApplicationBackground>
  );
};
